<template>
  <v-container>
    <v-card>
      <v-card-title>
        Box Sign In
        <v-icon right>mdi-login-variant</v-icon>
      </v-card-title>
      <v-card-subtitle>
        <p><i>Log In.</i></p>
        <p>From main menu: Pilots.</p>
        <p>1: Select box. The selected box will change color. Note any red text/information about hight limit etc. </p>
        <p>2: Tap the button: SIGN IN. </p>
        <p>3: Tap the button: DONE or OK. </p>
        <p>Now you have Status, <v-chip color="red" small>START</v-chip> and ready to fly!</p>
      </v-card-subtitle>
    </v-card>
    <v-card>
      <v-card-title>
        When landed - change status
        <v-icon right>fa-smile-wink</v-icon>
      </v-card-title>
      <v-card-subtitle>
        <p>From main menu: Pilots <v-icon small>mdi-paragliding</v-icon></p>
        <p>1: Scroll to find your name (or use the search).</p>
        <p>2: Tap the Change status button. NB: Log in if the button is disabled.</p>
        <p>3: Select either <v-chip color="orange" small>LANDED</v-chip> or <v-chip color="green" small>EXIT</v-chip>.</p>
        <p>4: You may now add a message as well before you tap the Submit button.</p>
        <p><v-icon x-small>fa-lightbulb</v-icon><i> Message can also be added later or whithout changing status. (Normally it is no need to add a message.)</i></p>
        
        <p>5: Status <v-chip color="orange" small>LANDED</v-chip> of course means - you have landed, but also that transport is needed to return to the event location.</p>
        <p>6: Now it's time to Add your position.<kbd>See next help "How to Add your position"</kbd>.</p>
        <v-img :src="HelpLsb2" height="200px"  aspect-ratio="1" contain></v-img>
        <p>7: Status <v-chip color="green" small>EXIT</v-chip> means - you are done (Signed out).</p>
        <p><v-icon x-small>fa-lightbulb</v-icon><i> To start again - just repeat the steps above.</i></p>
      </v-card-subtitle>
    </v-card>
  </v-container>
</template>

<script>
export default {
    data () {
        return {
            HelpLsb1: require('@/assets/HelpLsb1.png'),
            HelpLsb2: require('@/assets/HelpLsb2.png')
        }
    }
}
</script>